import React from 'react';

import { locale } from '@trqk/utils';
import { IconWarningSign } from '@trqk/components';

import { footerHeight } from '../../constants';
import { useGapAnalysisTools } from '../../../../../../../../hooks';

/**
 * If one or more songIds was edited in a StatementWorkCell, this footer will show a message that
 * tells the user they need to apply their changes to see updated totals. Otherwise, it returns
 * null.
 * @returns JSX | null
 */
export const WorkStatementWorkFooter = (): JSX.Element | null => {
    const { context } = useGapAnalysisTools();
    const { currentChannelId } = context;
    const someMatchedWorkIdWasEdited = currentChannelId
        ? context.edits?.[currentChannelId]?.someMatchedWorkIdWasEdited ?? false
        : false;

    if (!someMatchedWorkIdWasEdited) {
        return null;
    }

    return (
        <div className="flex items-center" style={{ height: footerHeight }}>
            <IconWarningSign width={16} fillColor="quinary-700" />
            <p className="ml-1 not-italic font-medium text-quinary-700">
                {
                    locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_WORKS
                        .COLUMN_FOOTERS.STATEMENT_WORK
                }
            </p>
        </div>
    );
};
